import { $_app_server } from '@/_helpers'

export const fileService = {
  createDocument,
  createTemplate,
  
  deleteDocument,
  deleteTemplate,

  changeDocument,
  changeTemplate,

  copyDocument,
  copyTemplate,

  transformToTemplate,
  
  getMyTags,
  getMyFolders,
  createFolderWithName,
  renameTag,
  renameFolder,
  deleteTag,
  deleteFolder,

  getMyDocuments,
  getMyTemplates,
  
  getFileURL
}

// Create

function createDocument (file) {
  return $_app_server.post('mydocument', file).then(response => response.data)
}

function createTemplate (file) {
  return $_app_server.post('doctemplate', file).then(response => response.data)
}


// Delete

function deleteDocument (file) {
  return $_app_server.delete('mydocument/' + file.id).then(response => response.data)
}

function deleteTemplate (file) {
  return $_app_server.delete('doctemplate/' + file.id).then(response => response.data)
}


// Move / Rename / Tags

function changeDocument (file) {
  return $_app_server.put('mydocument', file).then(response => response.data)
}

function changeTemplate (file) {
  return $_app_server.put('doctemplate', file).then(response => response.data)
}


// Copy

function copyDocument (fileId, payload) {
  return $_app_server.post('mydocument/copy/' + fileId, payload).then(response => response.data)
}

function copyTemplate (fileId, payload) {
  return $_app_server.post('doctemplate/copy/' + fileId, payload).then(response => response.data)
}


// Transform

function transformToTemplate (fileId, payload) {
  return $_app_server.post('mydocument/totemplate/' + fileId, payload).then(response => response.data)
}


// Folders and Tags

function getMyTags () {
  return $_app_server.get('mytags').then(response => response.data)
}

function getMyFolders () {
  return $_app_server.get('myfolder').then(response => response.data)
}

function createFolderWithName(name) {
  return $_app_server.post('myfolder', { name }).then(response => response.data)
}

function renameTag (tag) {
  return $_app_server.put('mytags', tag).then(response => response.data)
}

function renameFolder (folder) {
  return $_app_server.put('myfolder', folder).then(response => response.data)
}

function deleteTag (tagId, targetId = null) {
  return $_app_server.delete(`mytags/${ tagId }${ targetId ? '/target/' + targetId : '' }`).then(response => response.data)
}

function deleteFolder (folderId, targetId = null) {
  return $_app_server.delete(`myfolder/${ folderId }${ targetId ? '/target/' + targetId : '' }`).then(response => response.data)
}


// Documents and Templates

function getMyDocuments () {
  return $_app_server.get('mydocument').then(response => response.data)
}

function getMyTemplates () {
  return $_app_server.get('doctemplate').then(response => response.data)
}


// Other

function getFileURL (fileId, isTemplate) {
  return isTemplate ? $_app_server.get('doctemplate/url/' + fileId).then(response => response.data) 
  : $_app_server.get('mydocument/url/' + fileId).then(response => response.data)
}